import { GynecologyModal } from './GynecologyModal.component'
import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'

const withUnmountHoc = withUnmountTransition(GynecologyModal)
export { withUnmountHoc as GynecologyModal }
